import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {SalesSelectors} from '../store/selectors';
import {OrdersActions} from '../store';

@Injectable()
export class SalesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {
    return this.loadSalesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadSalesDone(): Observable<boolean> {
    return this.store.pipe(
      select(SalesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {

          const params = {
            'order[createdAt]': 'desc'
          };

          this.store.dispatch(OrdersActions.ReadSales({page: 1, params}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
